module.exports = __webpack_public_path__ + "img/bttn-magnify.1d2b0eac.svg";